import React from "react";
import { FiDollarSign, FiCreditCard, FiCheck, FiCalendar, FiHash } from "react-icons/fi";

function PaymentCard({
    formData,
    handleInputChange,
    grandTotal,
}) {

    const paidAmount = Number(formData.paid_amount || 0);
    const dueAmount = Math.max(0, grandTotal - paidAmount);

    return (
        <div className="card shadow-sm border-0">
            <div className="custom-modal-header text-white">
                <h5 className="mb-0">
                    <FiCreditCard className="me-2" />
                    Payment Details
                </h5>
            </div>

            <div className="card-body">
                <div className="row g-3">
                    <div className="col-md-6">
                        <label className="form-label fw-semibold">
                            <FiDollarSign className="me-1" /> Payment Method
                        </label>
                        <select
                            className="form-select"
                            name="payment_type"
                            value={formData.payment_type}
                            onChange={handleInputChange}
                        >
                            <option value="cash">💵 Cash</option>
                            <option value="bank_transfer">🏦 Bank Transfer</option>
                            <option value="cheque">📝 Cheque</option>
                            <option value="upi">📱 UPI</option>
                            <option value="credit">💳 Credit</option>
                        </select>
                    </div>


                    <div className="col-md-6">
                        <label className="form-label fw-semibold">
                            Paid Amount <span className="text-danger">*</span>
                        </label>
                        <input
                            type="number"
                            step="0.01"
                            className="form-control"
                            name="paid_amount"
                            value={formData.paid_amount}
                            onChange={handleInputChange}
                            placeholder="0.00"
                        />
                    </div>
                    <div className="col-md-6">
                        <label className="form-label fw-semibold">Due Amount</label>
                        <input
                            type="text"
                            className="form-control bg-light fw-bold"
                            value={`₹ ${dueAmount.toFixed(2)}`}
                            readOnly
                        />
                    </div>

                    <div className="col-md-6">
                        <label className="form-label fw-semibold">
                            <FiHash className="me-1" /> Transaction No
                        </label>
                        <input
                            type="text"
                            className="form-control"
                            name="transaction_no"
                            value={formData.transaction_no || ""}
                            onChange={handleInputChange}
                            placeholder="TXN-123456"
                        />
                    </div>

                    <div className="col-md-6">
                        <label className="form-label fw-semibold">
                            <FiCalendar className="me-1" /> Payment Date
                        </label>
                        <input
                            type="date"
                            className="form-control"
                            name="payment_date"
                            value={formData.payment_date || new Date().toISOString().split('T')[0]}
                            onChange={handleInputChange}
                        />
                    </div>
                </div>

                {/* Grand Total Display */}
                <div className="mt-3 p-3 bg-success bg-opacity-10 rounded-3 border border-success">
                    <div className="d-flex justify-content-between align-items-center">
                        <span className="fw-bold text-success">Grand Total</span>
                        <span className="fs-4 fw-bold text-success">₹ {grandTotal.toFixed(2)}</span>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PaymentCard;